import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { blackColor, headingColor, primaryColor } from "theme";

import NoCarrierIcon from "../../../../../assets/no-carrier-found.svg";

const NoCarrier = ({ setShowNoCarrier, setScreen, setApplicationId, applicationId }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    >
      <img src={NoCarrierIcon} alt="no-carrier-icon" />
      <Typography
        variant="h4"
        sx={{
          color: blackColor,
          fontSize: "1rem",
          fontWeight: "600",
          textAlign: "center",
          mt: "12px"
        }}
      >
        No Eligible Carrier Found
      </Typography>
      <Typography
        sx={{
          fontSize: ".875rem",
          color: headingColor,
          width: "65%",
          textAlign: "center"
        }}
      >
        {
          "We're sorry! It looks like none of our carriers can provide a quote with the information you provided. Please try again by changing your inputs if possible!"
        }
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          mt: "24px"
        }}
      >
        <Button
          variant="secondary"
          sx={{ borderRadius: ".5rem", maxHeight: "43px" }}
          onClick={() => {
            navigate("/start-application");
            setScreen("ProductList");
            setApplicationId(null);
            setShowNoCarrier(false);
          }}
        >
          Cancel
        </Button>
        <Button
        disabled={!applicationId}
          onClick={() => {
            setShowNoCarrier(false);
            if (applicationId) {
              setScreen("CheckEligibility");
            }
          }}
          variant="secondary"
          sx={{
            borderRadius: ".5rem",
            maxHeight: "43px",
            bgcolor: primaryColor,
            color: "white"
          }}
        >
          Go Back
        </Button>
      </Box>
    </Box>
  );
};

export default NoCarrier;
